<script setup lang="ts">
  import { ROUTE_NAME_HISTORY_FORM_EMAIL } from '@/config/routeNames';
  import ElRouterLink from '@/components/common/ElRouterLink/ElRouterLink.vue';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col gap-4 rounded border border-blue-accessible bg-blue-extra-light px-4 py-5 text-center md:container md:px-8 md:py-6"
    data-testid="historyByMailHeaderBox"
  >
    <h2 class="h3">
      {{ t('pages.historyView.headerBox.title') }}
    </h2>
    <p>{{ t('pages.historyView.headerBox.content') }}</p>
    <ElRouterLink
      :to="{name: ROUTE_NAME_HISTORY_FORM_EMAIL}"
      secondary
      class="md:self-center bg-white"
    >
      {{ t('pages.historyView.headerBox.sendHistoryButton') }}
    </ElRouterLink>
  </div>
</template>
